import { Actor, CollisionType, Color, vec, Vector } from "excalibur";
import { VISUALS } from "../config";
import { WallCollision } from "../systems/CollisionGroups";

/**
 * WorldWall - Invisible boundary walls
 * 
 * Fixed collision actors at the edges of the world that only
 * collide with the Macrophage (not viruses), preventing the
 * player from being pushed off-camera.
 */
export class WorldWall extends Actor {
    constructor(x: number, y: number, width: number, height: number) {
        super({
            name: 'WorldWall',
            pos: vec(x, y),
            width: width,
            height: height,
            anchor: Vector.Half,
            collisionType: CollisionType.Fixed,
            collisionGroup: WallCollision, // Only blocks PlayerGroup
            color: Color.Transparent,
        });
    }
}

/**
 * Create all four walls around the world edges
 */
export function createWorldWalls(): WorldWall[] {
    const wallThickness = 100;

    return [
        // Top wall
        new WorldWall(
            VISUALS.WORLD_WIDTH / 2,
            -wallThickness / 2,
            VISUALS.WORLD_WIDTH + wallThickness * 2,
            wallThickness
        ),
        // Bottom wall
        new WorldWall(
            VISUALS.WORLD_WIDTH / 2,
            VISUALS.WORLD_HEIGHT + wallThickness / 2,
            VISUALS.WORLD_WIDTH + wallThickness * 2,
            wallThickness
        ),
        // Left wall
        new WorldWall(
            -wallThickness / 2,
            VISUALS.WORLD_HEIGHT / 2,
            wallThickness,
            VISUALS.WORLD_HEIGHT + wallThickness * 2
        ),
        // Right wall
        new WorldWall(
            VISUALS.WORLD_WIDTH + wallThickness / 2,
            VISUALS.WORLD_HEIGHT / 2,
            wallThickness,
            VISUALS.WORLD_HEIGHT + wallThickness * 2
        ),
    ];
}
